import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "aw-marketo-form" }
const _hoisted_2 = {
  class: "aw-form",
  ref: "root"
}
const _hoisted_3 = { ref: "formEl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScriptComponent = _resolveComponent("ScriptComponent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, null, 512),
      (_ctx.formScript)
        ? (_openBlock(), _createBlock(_component_ScriptComponent, {
            value: _ctx.formScript,
            onOnscriptloaded: _ctx.scriptLoaded,
            key: _ctx.formScript
          }, null, 8, ["value", "onOnscriptloaded"]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}